import Checkbox from 'antd/lib/checkbox';
import type { StyledComponent } from 'styled-components';
import styled from 'styled-components';

export const StyledCheckbox: StyledComponent<typeof Checkbox, any> = styled(Checkbox)``;
